import { render, staticRenderFns } from "./noPrintTips.vue?vue&type=template&id=0c6ac33c&scoped=true"
import script from "./noPrintTips.vue?vue&type=script&lang=js"
export * from "./noPrintTips.vue?vue&type=script&lang=js"
import style0 from "./noPrintTips.vue?vue&type=style&index=0&id=0c6ac33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6ac33c",
  null
  
)

export default component.exports